import React, { useRef } from "react";
import { Card, Form, Button, Col } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";

const TopUPOption = (props) => {

  const formik = useFormik({
    initialValues: {
      amount: "",
    },
    validationSchema: Yup.object({
      amount: Yup.string().required("required"),
    }),
    onSubmit: (values) => {
      props.topUp(values.amount);
    },
  });

  return (
    <div className="mt-5">
      <Card className="my-5">
        <Card.Header className="bg-white py-3">
          <Card.Title>
            <h3>Topup Your Account </h3>
            <h4>Pcari token dose not expier, Topup for ever</h4>
          </Card.Title>
        </Card.Header>
        <Card.Body>
          <Form onSubmit={formik.handleSubmit}>
            <Form.Group as={Col} md="8">
              <Form.Label>Select Amount</Form.Label>
              <Form.Control
                as="select"
                isValid={formik.touched.amount && !formik.errors.amount}
                isInvalid={formik.touched.amount && formik.errors.amount}
                {...formik.getFieldProps("amount")}
              >
                <option hidden value>
                  Topup Amount
                </option>
                <option value="10">RM10</option>
                <option value="50">RM50</option>
                <option value="100">RM100</option>
                <option value="150">RM150</option>
                <option value="200">RM200</option>
                <option value="500">RM500</option>
                <option value="1000">RM1000</option>
                <option value="2000">RM2000</option>
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                amount is required
              </Form.Control.Feedback>
            </Form.Group>
            <Button
              type="submit"
              variant="primary"
              size="lg"
              className="text-white mx-auto my-3"
            >
              Submit
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default TopUPOption;
